export default {"src":"/_next/static/media/Cooper-Ray4.f6b50d10.JPG","height":362,"width":550};